import BaseStore from '@/store/base-store'

const options = {
  actions: {
    clear ({ commit }) {
      commit('item', {})
    }
  }
}
export default new BaseStore('opportunities', options)



// WEBPACK FOOTER //
// ./src/store/modules/opportunities.store.js